import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { PeopleflowFooterComponent } from '../peopleflow-footer/peopleflow-footer.component';
import { HeaderOneComponent } from '../shared/header/header-one/header-one.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrl: './vendor.component.scss',
  imports: [PeopleflowFooterComponent, HeaderOneComponent, RouterOutlet],
  // schemas: [NO_ERRORS_SCHEMA],
})
export class VendorComponent {
  [key: string]: any;
  constructor() {}
}
